import { render } from "./HeadComponent.vue?vue&type=template&id=787985ea"
import script from "./HeadComponent.vue?vue&type=script&lang=js"
export * from "./HeadComponent.vue?vue&type=script&lang=js"

import "./HeadComponent.vue?vue&type=style&index=0&id=787985ea&lang=css"

import exportComponent from "D:\\园域\\gfast-open\\huizhan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__